<template>
  <Dialog
    titleAlign="left"
    :title="$$t('create.more')"
    :visible="renderData.visible"
    @close="onClose"
    customClass="audio-item-op-items-dialog"
    mobileRenderType="drawerDialog"
  >
    <div
      class="audio-item-op-items-dialog-content"
      :class="`audio-item-op-items-dialog-content--${props.listRenderType}`"
    >
      <div
        class="audio-item-op-item-top-box flex"
        v-if="
          !(
            isDisableByAudit() ||
            (props.pitem.state == 2 && !props.item.stream_key)
          ) && props.renderType != 'createdetail'
        "
      >
        <div
          class="audio-item-op-item-top-item like-box"
          v-if="
            (!(
              isDisableByAudit() ||
              (props.pitem.state == 2 && !props.item.stream_key)
            ) &&
              props.renderType != 'createdetail') ||
            (!(
              isDisableByAudit() ||
              (props.pitem.state == 2 && !props.item.stream_key)
            ) &&
              props.renderType != 'createdetail' &&
              props.pitem?.generation_method != 6)
          "
        >
          <Button
            @click="doLike"
            :renderStyle="{
              '--padding': '0 15px',
              '--width': '100%',
              '--height': '42px',
              '--borderRadius': '50px',
              '--background': 'rgba(148, 173, 255, 0.2)',
              '--fontColor': '#fff',
              '--fontSize': '14px',
              '--fontWeight': '500',
              '--border': 'none',
              '--backgroundHover': 'rgba(148, 173, 255, 0.3)',
              '--fontColor': '#fff',
            }"
          >
            <i
              class="audio-item-op-item-top-item-ico"
              :class="{
                'audio-liked': props.item.is_liked == 1,
                'audio-unlike': props.item.is_liked != 1,
              }"
            ></i>
            <span>
              {{
                props.item.is_liked == 1
                  ? $$t("create.liked")
                  : $$t("create.like")
              }}
            </span>
          </Button>
        </div>
        <div
          class="audio-item-op-item-top-item share-box"
          v-if="
            !(
              isDisableByAudit() ||
              (props.pitem.state == 2 && !props.item.stream_key)
            ) &&
            props.renderType != 'createdetail' &&
            props.pitem?.generation_method != 6
          "
        >
          <Button
            @click="doShare"
            :renderStyle="{
              '--padding': '0 15px',
              '--width': '100%',
              '--height': '42px',
              '--borderRadius': '50px',
              '--background': 'rgba(148, 173, 255, 0.2)',
              '--fontColor': '#fff',
              '--fontSize': '14px',
              '--fontWeight': '500',
              '--border': 'none',
              '--backgroundHover': 'rgba(148, 173, 255, 0.3)',
              '--fontColor': '#fff',
            }"
          >
            <i class="audio-item-op-item-top-item-ico share-ico"></i>
            <span>{{ $$t("create.share") }}</span>
          </Button>
        </div>
      </div>
      <div
        class="audio-item-op-item audio-item-op-item-regenerate"
        v-if="
          !(
            props.isGenerating ||
            isDisableByAudit() ||
            props.pitem?.state == 2 ||
            props.pitem?.generation_method == 7
          ) &&
          (!ModuleOpenStateControl.editor.regionEditing ||
            (ModuleOpenStateControl.editor.regionEditing &&
              props.duration > 30))
        "
        @click="doRegenerate"
      >
        <i class="fn-inline"></i>
        <span class="fn-inline olh">{{
          ModuleOpenStateControl.editor.regionEditing
            ? $$t("editor.region_editing")
            : $$t("create.regenerate")
        }}</span>
        <label
          class="vip_plan"
          v-if="!['pro'].includes(userInfo?.user?.vip_level_name)"
        >
          {{ $$t("create.pro_plan") }}
        </label>
        <label
          class="beta_plan tc"
          v-if="ModuleOpenStateControl.editor.regionEditingBeta"
        >
          {{ $$t("create.beta") }}
        </label>
        <div
          class="vip_plan-mask"
          @click.stop="
            (e) => {
              goSubscribe(e, 'region_editing');
            }
          "
          v-if="!['pro'].includes(userInfo?.user?.vip_level_name)"
        ></div>
      </div>
      <div
        class="audio-item-op-item audio-item-op-item-extend"
        v-if="
          !(
            props.isGenerating ||
            isDisableByAudit() ||
            props.pitem.state == 2 ||
            props.pitem?.generation_method == 7
          ) &&
          (ModuleOpenStateControl.editor.extendEditing ||
            (!ModuleOpenStateControl.editor.extendEditing &&
              props.duration < 60 * 4.5))
        "
        @click="doExtend"
      >
        <i class="fn-inline"></i>
        <span class="fn-inline olh">{{
          ModuleOpenStateControl.editor.extendEditing
            ? $$t("editor.extend_editing")
            : $$t("create.extend")
        }}</span>
        <label
          class="vip_plan"
          v-if="!['pro'].includes(userInfo?.user?.vip_level_name)"
        >
          {{ $$t("create.pro_plan") }}
        </label>
        <label
          class="beta_plan tc"
          v-if="ModuleOpenStateControl.editor.extendEditingBeta"
        >
          {{ $$t("create.beta") }}
        </label>

        <div
          class="vip_plan-mask"
          @click.stop="
            (e) => {
              goSubscribe(e, 'extend');
            }
          "
          v-if="!['pro'].includes(userInfo?.user?.vip_level_name)"
        ></div>
      </div>
      <div
        class="audio-item-op-item audio-item-op-item-trim"
        v-if="
          !(
            props.isGenerating ||
            isDisableByAudit() ||
            props.pitem?.state == 2
          ) &&
          ModuleOpenStateControl.editor.trimEditing &&
          props.duration > 30
        "
        @click="doTrimEditing"
      >
        <i class="fn-inline"></i>
        <span class="fn-inline olh">
          {{ $$t("editor.trim") }}
        </span>
        <!-- <label class="vip_plan_basic" v-if="!userInfo?.user?.is_vip">
          {{ $$t("create.basic_plan") }}
        </label> -->
        <label
          class="beta_plan tc"
          v-if="ModuleOpenStateControl.editor.trimEditingBeta"
        >
          {{ $$t("create.beta") }}
        </label>

        <!-- <div
          class="vip_plan-mask"
          @click.stop="
            (e) => {
              goSubscribe(e, 'trim_editing');
            }
          "
          v-if="!userInfo?.user?.is_vip"
        ></div> -->
      </div>
      <div
        class="audio-item-op-item audio-item-op-item-lyrics-translate"
        v-if="
          !(
            props.isGenerating ||
            isDisableByAudit() ||
            props.pitem.state == 2 ||
            props.pitem?.generation_method == 7
          ) && ModuleOpenStateControl.editor.lyricsTranslate
        "
        @click="doLyricsTranslate"
      >
        <i class="fn-inline"></i>
        <span class="fn-inline olh"> {{ $$t("editor.lyrics_translate") }}</span>
        <label
          class="vip_plan"
          v-if="!['pro'].includes(userInfo?.user?.vip_level_name)"
        >
          {{ $$t("create.pro_plan") }}
        </label>
        <label
          class="beta_plan tc"
          v-if="ModuleOpenStateControl.editor.lyricsTranslateBeta"
        >
          {{ $$t("create.beta") }}
        </label>
        <div
          class="vip_plan-mask"
          @click.stop="
            (e) => {
              goSubscribe(e, 'lyrics_translate');
            }
          "
          v-if="!['pro'].includes(userInfo?.user?.vip_level_name)"
        ></div>
      </div>
      <div
        class="audio-item-op-item audio-item-op-item-cover-voice"
        v-if="
          !(
            props.isGenerating ||
            isDisableByAudit() ||
            props.pitem.state == 2 ||
            props.pitem?.generation_method == 7
          ) && ModuleOpenStateControl.editor.coverVoice
        "
        @click="doCoverVoice"
      >
        <i class="fn-inline"></i>
        <span class="fn-inline olh"> {{ $$t("editor.cover_voice") }}</span>
        <label
          class="vip_plan"
          v-if="!['pro'].includes(userInfo?.user?.vip_level_name)"
        >
          {{ $$t("create.pro_plan") }}
        </label>

        <div
          class="vip_plan-mask"
          @click.stop="
            (e) => {
              goSubscribe(e, 'cover_voice');
            }
          "
          v-if="!['pro'].includes(userInfo?.user?.vip_level_name)"
        ></div>
        <label
          class="beta_plan tc"
          v-if="ModuleOpenStateControl.editor.coverVoiceBeta"
        >
          {{ $$t("create.beta") }}
        </label>
      </div>

      <!-- <div
        class="audio-item-op-item"
        v-if="
          !(
            isDisableByAudit() ||
            (props.pitem.state == 2 && !props.item.stream_key)
          ) && props.renderType != 'createdetail'
        "
        :class="{
          'audio-item-op-item-like': props.item.is_liked == 1,
          'audio-item-op-item-unlike': props.item.is_liked != 1,
        }"
        @click="doLike"
      >
        <i class="fn-inline"></i>
        <span class="fn-inline olh">{{
          props.item.is_liked == 1 ? $$t("create.liked") : $$t("create.like")
        }}</span>
      </div>
      <div
        class="audio-item-op-item audio-item-op-item-share"
        v-if="
          !(
            isDisableByAudit() ||
            (props.pitem.state == 2 && !props.item.stream_key)
          ) &&
          props.renderType != 'createdetail' &&
          props.pitem?.generation_method != 6
        "
        @click="doShare"
      >
        <i class="fn-inline"></i>
        <span class="fn-inline olh">{{ $$t("create.share") }}</span>
      </div> -->
      <div
        class="audio-item-op-item audio-item-op-item-sell"
        v-if="
          !(
            props.isGenerating ||
            isDisableByAudit() ||
            props.pitem.state == 2
          ) &&
          props.renderType != 'createdetail' &&
          !props.pitem?.is_generated_from_uploaded_file
        "
        @click="doAddShoping"
      >
        <i class="fn-inline"></i>
        <span class="fn-inline olh">{{
          [1, 3].includes(props.item?.publish_state)
            ? createRenderType == "mobile"
              ? $$t("create.unpublish")
              : $$t("create.published")
            : $$t("create.song_apply_to_publish")
        }}</span>
      </div>

      <div
        class="audio-item-op-item audio-item-op-item-release"
        v-if="
          !(
            props.isGenerating ||
            isDisableByAudit() ||
            props.pitem.state == 2
          ) && ModuleOpenStateControl.create.release
        "
        @click="doRelease"
      >
        <i class="fn-inline"></i>
        <span class="fn-inline olh">{{
          props.item?.release_info?.release_state == 4
            ? $$t("create.released")
            : !props.item?.release_info?.release_state
            ? $$t("create.release")
            : $$t("create.releasing")
        }}</span>
      </div>

      <!-- <div
        class="audio-item-op-item audio-item-op-item-sell"
        v-if="props.item.state == 1"
        :class="{
          disabled: true,
        }"
      >
        <i class="fn-inline"></i>
        <span class="fn-inline olh">{{
          $$t("create.song_sale_under_review")
        }}</span>
      </div>

      <div
        class="audio-item-op-item audio-item-op-item-sell"
        v-if="props.item.state == 2"
        :class="{
          disabled: true,
        }"
      >
        <i class="fn-inline"></i>
        <span class="fn-inline olh">{{ $$t("create.song_on_sale") }}</span>
      </div>

      <div
        class="audio-item-op-item audio-item-op-item-sell"
        v-if="props.item.state == 3"
        :class="{
          disabled: true,
        }"
      >
        <i class="fn-inline audio-item-op-item-sell"></i>
        <span class="fn-inline olh">{{ $$t("create.song_suspend_sale") }}</span>
      </div>

      <div
        class="audio-item-op-item audio-item-op-item-sell"
        v-if="props.item.state == 4"
        :class="{
          disabled: true,
        }"
      >
        <i class="fn-inline"></i>
        <span class="fn-inline olh">{{ $$t("create.song_sold_out") }}</span>
      </div>

      <div
        class="audio-item-op-item audio-item-op-item-sell"
        v-if="props.item.state == 5"
        :class="{
          disabledui: true,
        }"
      >
        <i class="fn-inline"></i>
        <span class="fn-inline olh">{{
          $$t("create.song_sale_review_failed")
        }}</span>
        <i class="fn-inline tc info-ico" @click="openSaleReviewFailedReason">
        </i>
      </div> -->
      <div
        class="audio-item-op-item audio-item-op-item-download-video"
        v-if="
          !(
            [2, 3, 5, 6, 8].includes(props.pitem?.generation_method) &&
            props.pitem?.is_generated_from_uploaded_file
          ) &&
          !(props.isGenerating || isDisableByAudit() || props.pitem.state == 2)
        "
        @click="doDownloadVideo"
      >
        <i class="fn-inline"></i>
        <span class="fn-inline olh">{{ $$t("create.download_video") }}</span>
        <label
          class="vip_plan"
          v-if="!['pro'].includes(userInfo?.user?.vip_level_name)"
        >
          {{ $$t("create.pro_plan") }}
        </label>
        <div
          class="vip_plan-mask"
          @click.stop="
            (e) => {
              goSubscribe(e, 'download_video');
            }
          "
          v-if="!['pro'].includes(userInfo?.user?.vip_level_name)"
        ></div>
      </div>
      <div
        class="audio-item-op-item audio-item-op-item-download-ws"
        v-if="
          !(props.isGenerating || isDisableByAudit() || props.pitem.state == 2)
        "
        @click="doDownloadWAVAndStem"
      >
        <i class="fn-inline"></i>
        <span class="fn-inline olh">{{ $$t("create.download_wav_mp3") }}</span>
        <label
          class="vip_plan"
          v-if="!['pro'].includes(userInfo?.user?.vip_level_name)"
        >
          {{ $$t("create.pro_plan") }}
        </label>

        <div
          class="vip_plan-mask"
          @click.stop="
            (e) => {
              goSubscribe(e, 'download_instrumental_stem');
            }
          "
          v-if="!['pro'].includes(userInfo?.user?.vip_level_name)"
        ></div>
      </div>
      <div
        class="audio-item-op-item audio-item-op-item-download-oc"
        v-if="
          !(
            props.isGenerating ||
            isDisableByAudit() ||
            props.pitem.state == 2
          ) && !props.pitem?.is_generated_from_uploaded_file
        "
        @click="doDownloadCopyright"
      >
        <i class="fn-inline"></i>
        <span class="fn-inline olh">{{
          $$t("create.download_copyright")
        }}</span>
        <label class="vip_plan_basic" v-if="!userInfo?.user?.is_vip">
          {{ $$t("create.basic_plan") }}
        </label>

        <div
          class="vip_plan-mask"
          @click.stop="
            (e) => {
              goSubscribe(e, 'download_license');
            }
          "
          v-if="!userInfo?.user?.is_vip"
        ></div>
      </div>
      <div
        v-if="
          !(
            props.isGenerating ||
            isDisableByAudit() ||
            props.pitem.state == 2
          ) && props.renderType != 'createdetail'
        "
        class="audio-item-op-item audio-item-op-item-download-mp3"
        @click="doDownloadMp3"
      >
        <i class="fn-inline"></i>
        <span class="fn-inline olh">{{
          props.pitem?.generation_method == 2
            ? $$t("editor.download_whole_mp3")
            : $$t("create.download_mp3")
        }}</span>
        <label class="vip_plan_basic" v-if="!userInfo?.user?.is_vip">
          {{ $$t("create.basic_plan") }}
        </label>

        <div
          class="vip_plan-mask"
          @click.stop="
            (e) => {
              goSubscribe(e, 'download_mp3');
            }
          "
          v-if="!userInfo?.user?.is_vip"
        ></div>
      </div>
      <div
        v-if="
          !(
            props.isGenerating ||
            isDisableByAudit() ||
            props.pitem.state == 2
          ) &&
          ModuleOpenStateControl.editor.extendEditing &&
          props.pitem?.generation_method == 2
        "
        class="audio-item-op-item audio-item-op-item-download-extend-mp3"
        @click="doDownloadExtendMp3"
      >
        <i class="fn-inline"></i>
        <span class="fn-inline olh">
          {{ $$t("editor.download_extend_mp3") }}</span
        >
        <label class="vip_plan_basic" v-if="!userInfo?.user?.is_vip">
          {{ $$t("create.basic_plan") }}
        </label>

        <div
          class="vip_plan-mask"
          @click.stop="
            (e) => {
              goSubscribe(e, 'download_extend_mp3');
            }
          "
          v-if="!userInfo?.user?.is_vip"
        ></div>
      </div>
      <div
        class="audio-item-op-item audio-item-op-item-restore"
        v-if="
          !(props.isGenerating || isDisableByAudit() || props.pitem.state == 2)
        "
        @click="doRestore"
      >
        <i class="fn-inline"></i>
        <span class="fn-inline olh">{{ $$t("create.restore") }}</span>
      </div>

      <div
        class="audio-item-op-item audio-item-op-item-edit-song-title"
        v-if="
          !(
            props.isGenerating ||
            [1, 3].includes(props.item.publish_state) ||
            isDisableByAudit() ||
            props.pitem.state == 2
          )
        "
        @click="
          () => {
            doEditSongTitle();
          }
        "
      >
        <i class="fn-inline"></i>
        <span class="fn-inline olh">{{
          $$t("create.edit_feed_song_info")
        }}</span>
      </div>

      <div
        class="audio-item-op-item audio-item-op-item-delete"
        v-if="
          !(props.isGenerating || props.pitem.state == 2) && isAllowedDelete()
        "
        @click="doDelete"
      >
        <i class="fn-inline"></i>
        <span class="fn-inline olh">{{ $$t("create.delete") }}</span>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue";
import { useRouter, useRoute } from "vue-router";

import Button from "@/components/basic/button/Button.vue";

import globleConfig, {
  chinaAppName,
  ModuleOpenStateControl,
} from "@/config/config.js";

import { $$language, $$t } from "@/i18n/i18n.js";
import { storeToRefs } from "pinia";
import useUserDataStore from "@/store/userDataStore";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
const userDataStore = useUserDataStore();

const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);
const { userInfo } = storeToRefs(userDataStore);
const Router = useRouter();

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  renderType: {
    type: String,
    default: "create", // createdetail // store
  },
  duration: {
    type: Number,
    default: 0,
  },
  item: {
    type: Object,
    default: null,
  },
  pitem: {
    type: Object,
    default: null,
  },
  listRenderType: {
    type: String,
    default: "create",
  },
  isGenerating: {
    type: Boolean,
    default: false,
  },
});
const emits = defineEmits([
  "update:visible",
  "from",
  "restore",
  "regenerate",
  "extend",
  "trimEditing",
  "lyricsTranslate",
  "coverVoice",
  "like",
  "share",
  "more",
  "delete",
  "download",
  "addShoping",
  "release",
  "soldOut",
  "editSongTitle",
  "doDownloadVideo",
  "downloadMp3",
  "downloadExtendMp3",
  "downloadCopyright",
  "downloadWAVAndStem",
  "openSaleReviewFailedReason",
]);
const renderData = reactive({
  visible: props.visible,
});

const goSubscribe = async (e, membership_source2) => {
  e ?? window.event?.stopPropagation();
  if (await userDataStore.checkLoginStatus()) {
    Router.push({
      name: "subscribe",
      query: {
        membership_source1: "membership_feature",
        membership_source2,
      },
    });
  }
};

const isDisableByAudit = () => {
  //2-ing 3- chenggong 4-failed
  // int64 machine_audit_state = 11;
  return (
    [4, 5].includes(props.item?.machine_audit_state) ||
    props.pitem.state == 12 ||
    (globleConfig.appname == chinaAppName && props.pitem?.state == 2)
  );
};

const isAllowedDelete = () => {
  return true;
};

const onClose = () => {
  renderData.visible = false;
};

const doRestore = () => {
  emits("restore", props.pitem, props.item);
  renderData.visible = false;
};

const doRegenerate = () => {
  emits("regenerate", props.pitem, props.item);
  renderData.visible = false;
};

const doExtend = () => {
  emits("extend", props.pitem, props.item);
  renderData.visible = false;
};

const doTrimEditing = () => {
  emits("trimEditing", props.pitem, props.item);
  renderData.visible = false;
};

const doLyricsTranslate = () => {
  emits("lyricsTranslate", props.pitem, props.item);
  renderData.visible = false;
};

const doCoverVoice = () => {
  emits("coverVoice", props.pitem, props.item);
  renderData.visible = false;
};
const doFrom = () => {
  emits("from", props.pitem, props.item);
  renderData.visible = false;
};

const doLike = () => {
  emits("like", props.pitem, props.item);
};

const doDownload = () => {
  emits("download", props.pitem, props.item);
  renderData.visible = false;
};

const doDownloadVideo = () => {
  emits("doDownloadVideo", props.pitem, props.item);
  renderData.visible = false;
};

const doDownloadMp3 = () => {
  emits("downloadMp3", props.pitem, props.item);
  renderData.visible = false;
};

const doDownloadExtendMp3 = () => {
  emits("downloadExtendMp3", props.pitem, props.item);
  renderData.visible = false;
};

const doDownloadCopyright = () => {
  emits("downloadCopyright", props.pitem, props.item);
  renderData.visible = false;
};

const doDownloadWAVAndStem = () => {
  emits("downloadWAVAndStem", props.pitem, props.item);
  renderData.visible = false;
};

const doShare = () => {
  emits("share", props.pitem, props.item, (isSuccess) => {
    if (isSuccess) {
      // $$t("create.song_link_copied");
    }
  });
  renderData.visible = false;
};

const doAddShoping = () => {
  emits("addShoping", props.pitem, props.item);
  renderData.visible = false;
};

const doRelease = () => {
  emits("release", props.pitem, props.item);
  renderData.visible = false;
};
const doSoldOut = () => {
  emits("soldOut", props.pitem, props.item);
  renderData.visible = false;
};

const doDelete = () => {
  emits("delete", props.pitem, props.item);
  renderData.visible = false;
};

const doEditSongTitle = () => {
  emits("editSongTitle", props.pitem, props.item);
  renderData.visible = false;
};

const openSaleReviewFailedReason = () => {
  emits("openSaleReviewFailedReason", props.pitem, props.item);
};

watch(
  () => props.visible,
  (val) => {
    renderData.visible = props.visible;
  }
);

watch(
  () => renderData.visible,
  (val) => {
    emits("update:visible", val);
  }
);

onMounted(() => {});
</script>
<style lang="scss">
.audio-item-op-items-dialog {
  padding: 0 0 0 16px;
  .dialog-box{
    max-height: 80%!important;
  }
  .dialog-header {
    padding: 0 60px 0 20px;
  }
  .audio-item-op-items-dialog-content {
    padding: 0 0 32px 0;
  }
  .audio-item-op-items-dialog-content--likemysong {
    .audio-item-op-item-like {
      display: none;
    }
  }
  .audio-item-op-item-top-box {
    padding: 12px 20px 12px 20px;
    .audio-item-op-item-top-item {
      width: 0;
      flex: 1;
      &.share-box {
        margin-left: 8px;
      }
    }
    .audio-item-op-item-top-item-ico {
      height: 20px;
      width: 20px;
      margin-right: 8px;
      &.audio-liked {
        background: url("@/assets/img/like-ico.png");
        background-size: 100% 100%;
      }
      &.audio-unlike {
        background: url("@/assets/img/audio-notlike-m-ico.png");
        background-size: 100% 100%;
      }
      &.share-ico {
        background: url("@/assets/img/audio-share-m-ico.png");
        background-size: 100% 100%;
      }
    }
  }
  .audio-item-op-item {
    height: 44px;
    padding: 0 20px;
    line-height: 44px;
    position: relative;
    cursor: pointer;
    display: flex;
    align-items: center;

    i {
      width: 20px;
      height: 20px;
      display: none;
    }
    span {
      font-family: HarmonyOS Sans SC;
      font-size: 14px;
      font-weight: 500;
      line-height: 18px;
      color: #ffffff;
      // margin-left: 12px;
      margin: 0;
      flex: 0 1 1;
    }
    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
    }
    &.disabledui {
      opacity: 0.5;
      i,
      span {
        cursor: not-allowed;
      }
      i.info-ico {
        cursor: pointer;
      }
    }
    i.info-ico {
      width: 20px;
      height: 20px;
      background: url("@/assets/img/question-ico.png") !important;
      background-size: 100% 100% !important;
      border-radius: 20px;
      margin-left: 4px;
    }
    label.vip_plan {
      display: inline-block;
      min-width: max-content;
      height: 14px;
      border-radius: 2px;
      padding: 0 3px;
      line-height: 14px;
      font-family: Source Han Sans;
      font-size: 8px;
      font-weight: 500;
      background: linear-gradient(
        110deg,
        #ffe08b 0%,
        #fff7d0 47%,
        #ffe08b 100%
      );
      color: #3d2d00;
      margin: 0 0 0 6px;
    }
    label.vip_plan_basic {
      display: inline-block;
      min-width: max-content;
      height: 14px;
      border-radius: 2px;
      padding: 0 3px;
      line-height: 14px;
      font-family: Source Han Sans;
      font-size: 8px;
      font-weight: 500;
      background: linear-gradient(
        107deg,
        #84d8ff 0%,
        #afe6ff 50%,
        #84d8ff 100%
      );
      color: #173b70;
      margin: 0 0 0 6px;
    }
    label.beta_plan {
      display: inline-block;
      min-width: max-content;
      height: 14px;
      border-radius: 2px;
      padding: 0 3px;
      line-height: 14px;
      font-family: Source Han Sans;
      font-size: 8px;
      font-weight: 500;
      background: rgba(255, 255, 255, 0.2);
      color: #fff;
      margin: 0 0 0 6px;
    }

    .vip_plan-mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
  .audio-item-op-item-regenerate {
    i {
      background: url("@/assets/img/audio-regenerate-m-ico.png");
      background-size: 100% 100%;
    }
  }
  .audio-item-op-item-extend {
    i {
      background: url("@/assets/img/audio-extend-m-ico.png");
      background-size: 100% 100%;
    }
  }
  .audio-item-op-item-trim {
    i {
      background: url("@/assets/img/editor/icon-trim.png");
      background-size: 100% 100%;
      opacity: 0.5;
    }
  }
  .audio-item-op-item-lyrics-translate {
    i {
      background: url("@/assets/img/editor/icon-translate.png");
      background-size: 100% 100%;
      opacity: 0.5;
    }
  }

  .audio-item-op-item-like {
    i {
      background: url("@/assets/img/like-ico.png");
      background-size: 100% 100%;
    }
  }

  .audio-item-op-item-unlike {
    i {
      background: url("@/assets/img/audio-notlike-m-ico.png");
      background-size: 100% 100%;
    }
  }

  .audio-item-op-item-share {
    i {
      background: url("@/assets/img/audio-share-m-ico.png");
      background-size: 100% 100%;
    }
  }

  .audio-item-op-item-sell {
    i {
      background: url("@/assets/img/more-publish.png");
      background-size: 100% 100%;
    }
  }

  .audio-item-op-item-release {
    i {
      background: url("@/assets/img/more-release.png");
      background-size: 100% 100%;
    }
  }

  .audio-item-op-item-download-video {
    i {
      background: url("@/assets/img/audio-video-m-ico.png");
      background-size: 100% 100%;
    }
  }

  .audio-item-op-item-download-mp3 {
    i {
      // background: url("@/assets/img/audio-download-mp3-ico.png");
      background: url("@/assets/img/download-audio-ico.png");
      background-size: 100% 100%;
    }
  }
  .audio-item-op-item-download-extend-mp3 {
    i {
      background: url("@/assets/img/download-extend-audio-ico.png");
      background-size: 100% 100%;
    }
  }

  .audio-item-op-item-download-oc {
    i {
      background: url("@/assets/img/audio-download-oc-m-ico.png");
      background-size: 100% 100%;
    }
  }

  .audio-item-op-item-download-ws {
    i {
      background: url("@/assets/img/audio-download-ws-m-ico.png");
      background-size: 100% 100%;
    }
  }

  .audio-item-op-item-restore {
    i {
      background: url("@/assets/img/audio-restore-m-ico.png");
      background-size: 100% 100%;
    }
  }

  .audio-item-op-item-edit-song-title {
    i {
      background: url("@/assets/img/audio-edit-m-ico.png");
      background-size: 100% 100%;
    }
  }

  .audio-item-op-item-delete {
    i {
      background: url("@/assets/img/audio-delete-m-ico.png");
      background-size: 100% 100%;
    }
  }
}
</style>
